import TopWelcomeBlock from './TopWelcomeBlock';

export default TopWelcomeBlock;
